/* eslint-disable clubmed/no-fake-component */
import React from 'react';
import { t } from 'Src/i18n';
import { IS_VALID } from 'Components/frameworks/form-validator-hoc/validationStates';
import { InputSelect } from 'Components/frameworks/form-inputs/input-select/InputSelect';
import { ErrorNote } from 'Components/frameworks/formik/formik-input/ErrorNote';
import { getTransferOptions, getTransferFromValue, getTransferLabelKey } from './transferUtils';
import { TransferSelectionButton } from './TransferSelectionButton';
type TransferSelectionProps = {
  addedTransfer?: UpsellTransfer | null;
  bookingId?: string;
  validTransfers: Array<UpsellTransfer>;
  setSelectedTransfer: (arg0: UpsellTransfer | null) => void;
  addTransfer: (arg0: UpsellTransfer) => Promise<unknown>;
  removeTransfer: (arg0: UpsellTransfer) => Promise<unknown>;
  selectedTransfer: UpsellTransfer | null;
};
export const TransferSelection = ({
  addedTransfer,
  bookingId,
  validTransfers,
  selectedTransfer,
  addTransfer,
  removeTransfer,
  setSelectedTransfer,
}: TransferSelectionProps) => {
  const isTransferAdded = !!addedTransfer;
  const isTransferSelected = !!selectedTransfer;
  const validationState = isTransferSelected && !isTransferAdded ? IS_VALID : '';
  const transferLabel = t(getTransferLabelKey((addedTransfer ?? selectedTransfer)?.directionType));
  const dataSelector = 'transfersSection';
  const [hasError, setHasError] = React.useState(false);

  const handleSelectChange = (_name: string, value: string) => {
    setHasError(false);
    setSelectedTransfer(getTransferFromValue(validTransfers, value));
  };

  const transfersOptions = getTransferOptions(
    validTransfers,
    t('booking.transport.transfer.chooseTransfer'),
  );
  return (
    <div data-testid="TransferSelection" className="w-full py-10">
      <div className="gap-20 md:flex">
        <div className="mb-15 md:mb-0 md:w-3/5">
          <InputSelect
            label={transferLabel}
            dataTestId={`${dataSelector}TransfersOptions`}
            onChange={handleSelectChange}
            isReadOnly={isTransferAdded || (isTransferSelected && validTransfers.length <= 1)}
            options={transfersOptions}
            validationState={validationState}
            value={
              isTransferAdded ? addedTransfer.pricingInfo.id : selectedTransfer?.pricingInfo.id
            }
          />
          {hasError && (
            <ErrorNote
              className="mx-15 md:hidden"
              isErrored={hasError}
              errorMessage={t('booking.transport.transfer.errorTransfer')}
            />
          )}
        </div>
        <TransferSelectionButton
          bookingId={bookingId}
          dataSelector={dataSelector}
          addedTransfer={addedTransfer}
          addTransfer={addTransfer}
          removeTransfer={removeTransfer}
          selectedTransfer={selectedTransfer}
          setHasError={setHasError}
        />
      </div>
      {hasError && (
        <ErrorNote
          className="mx-15 hidden md:block"
          isErrored={hasError}
          errorMessage={t('booking.transport.transfer.errorTransfer')}
        />
      )}
    </div>
  );
};
